import { MultiLevelDropdown } from "@/components/ui/MultiLevelDropdown";
import { Button } from "@paribus/shared-ui";
import { ChevronDown } from "lucide-react";

import type { CaseFilterMenuProps } from "./types";

export const CaseFilterMenu = ({
  filterTypes,
  activeFilters,
  getValueOptions,
  onToggleValue,
  isLoading,
}: CaseFilterMenuProps) => (
  <MultiLevelDropdown
    trigger={
      <Button variant="outline" size="sm" trailingIcon={<ChevronDown />}>
        Filter by...
      </Button>
    }
    groups={filterTypes.map(({ key, label }) => ({
      key,
      label,
      options: getValueOptions(key),
      isLoading,
    }))}
    values={activeFilters}
    onToggle={onToggleValue}
  />
);
